import {Draggable, gsap, InertiaPlugin} from "gsap/all";
import $ from "jquery";
import {BaseGameBBAI} from "../base/BaseGameBBAI";
import {CBMSMainAppScreenTransition} from "./CBMSMainAppScreenTransition";
import {Marquee} from "../ai-control/components/Marquee";
import {Notifications} from "./components/Notifications";
import {iFrameController} from "./components/iFrameController";
import {Scenario} from "./components/Scenario";
import {BlurryLettersAnimation} from "../base/BlurryLettersAnimation";

// Constructor
export class CBMSMainApp extends BaseGameBBAI {

  constructor() {
    super(`data/cbms-main.json`, 'cbms');
    gsap.registerPlugin(Draggable, InertiaPlugin);
    this.screenTransition = new CBMSMainAppScreenTransition();

    this.statusBar = null;
    this.notifications = null;
    this.iframeController = null;

    this.startTimeout = null;

    this.scenarios = {};
    this.selectedScenario = null;
  }

  loadRemoteContent() {
    this.data.cbms_iframe_url = this.settings.cbms_iframe_url;
    return super.loadRemoteContent();
  }

  initGame() {
    super.initGame();

    // Status bar
    this.statusBar = new Marquee({
      container: "#status-bar",
      track: ".status-bar",
      itemSelector: ".status-static-element",
      speed: 20
    });
    this.statusBar.init();

    // Notifications
    this.notifications = new Notifications();

    // iFrame Handler
    this.iframeController = new iFrameController();

    // First screen blurry letters
    this.blurryLettersAnim = new BlurryLettersAnimation(`#screen-1 .screen-content .title .${this.i18n.lang}`);

    // Build scenarios
    this.scenarios = {
      scenario1: new Scenario(this.findScenarioByMachineName(this.data.cms_content.scenarios, "scenario1"), this.iframeController, this.notifications),
      scenario2: new Scenario(this.findScenarioByMachineName(this.data.cms_content.scenarios, "scenario2"), this.iframeController, this.notifications),
      scenario3: new Scenario(this.findScenarioByMachineName(this.data.cms_content.scenarios, "scenario3"), this.iframeController, this.notifications),
      scenario4: new Scenario(this.findScenarioByMachineName(this.data.cms_content.scenarios, "scenario4"), this.iframeController, this.notifications),
      scenario5: new Scenario(this.findScenarioByMachineName(this.data.cms_content.scenarios, "scenario5"), this.iframeController, this.notifications, true),
    }

    this.initEvents();
  }

  initEvents() {
    // Debugging trigger rfid scans with key presses
    $(window).keypress((e) => {
      const keysMap = {
        "=": {
          id: null,
        },
        1: {
          id: "scenario1",
        },
        2: {
          id: "scenario2",
        },
        3: {
          id: "scenario3",
        },
        4: {
          id: "scenario4",
        },
        5: {
          id: "scenario5",
        }
      }

      if (e.key === "=") {
        this.cancelScenario();
      } else if (e.key === "d") {
        // Debug method to hide the iframe overlay so we can interact with the page if needed
        this.iframeController.setBlockOverlay();
      } else if (Object.hasOwn(keysMap, e.key)) {
        const id = keysMap[e.key].id;
        if (!this.scenarios[id]?.machineName) {
          console.warn(`Scenario "${id}" is not constructed (missing data), ignoring keypress`);
          return;
        }
        this.loadScenario(id);
      }
    });

    $(document).on(this.touchEvent, (e) => {
      // As requested by Sam on 2026-05-19, keep sending active on interactions
      app.sendScreenBridgeMessage("/send active");
    })

  }

  initScreen(screenId) {
    if (screenId === 2) {
      $("#screen-3 .scenario.selected").removeClass("selected");
    }

    if (screenId === 4) {
      this.scenarios[this.selectedScenario].off("completed").on("completed", () => {
        console.log("Scenario completed");
        setTimeout(() => this.cancelScenario(), 2000);
      });

      this.scenarios[this.selectedScenario].start();
    }

    // Start/stop initial screen blurry animation
    if (screenId === 1) this.blurryLettersAnim.play();
    else this.blurryLettersAnim.stop();
  }

  loadScenario(selectedScenario) {
    const $scenarios = $("#screen-3 .scenario");
    const $currentScenario = $scenarios.filter(".selected");

    // Scenario already selected
    if ($currentScenario.data("scenario-machine-name") === selectedScenario) return;

    // A scenario is already in progress, we need to clear it with cancelScenario
    // (back to screen 2, reset state) and reload from a clean slate. Otherwise
    // goToScreen with the same target screen (like scenario5 while already on
    // screen 4) does nothing and the new scenario never starts.
    if ($currentScenario.length > 0) {
      this.cancelScenario(() => this.loadScenario(selectedScenario));
      return;
    }

    if (this.startTimeout !== null) {
      clearTimeout(this.startTimeout)
      this.startTimeout = null;
    }

    // Show appropriate scenario
    const $selectedScenario = $(`#screen-3 .scenario[data-scenario-machine-name='${selectedScenario}']`)
    gsap.fromTo($selectedScenario, {y: 30, autoAlpha: 0}, {y: 0, autoAlpha: 1});
    $selectedScenario.addClass("selected");

    this.selectedScenario = selectedScenario;

    this.scenarios[this.selectedScenario].preload();

    // Scenario5 skips the intro screen and goes straight to the scenario
    if (selectedScenario === "scenario5") {
      this.goToScreen(4);
    } else {
      this.goToScreen(3);
    }

  }

  cleanUpScenario() {
    if (!this.selectedScenario || !this.scenarios[this.selectedScenario]) return;
    this.scenarios[this.selectedScenario].reset();
  }

  cancelScenario(onComplete = null) {
    const $scenarios = $("#screen-3 .scenario");

    this.goToScreen(2, () => {
      $scenarios.removeClass("selected");
      gsap.to($scenarios, {y: 30, autoAlpha: 0});

      this.cleanUpScenario();

      if (typeof onComplete === "function") onComplete();
    });
  }

  lockInteraction() {
    super.lockInteraction()
    this.sendScreenBridgeMessage("lockInteraction");
  }

  unlockInteraction() {
    super.unlockInteraction()
    this.sendScreenBridgeMessage("unlockInteraction");
  }

  startGame() {
    if (this.starting) return;
    this.starting = true;

    app.audio.play("audio/ButtonOnPress_260423.wav", 1, true)

    this.startTimeout = setTimeout(() => {
      this.sendScreenBridgeMessage("/send active");
      this.goToNextScreen();
      this.starting = false;
    }, 750);
  }

  startScenario() {
    app.audio.play("audio/ButtonOnClick_260423.wav", 1, true)

    this.startTimeout = setTimeout(() => {
      this.goToNextScreen();
    }, 150);
  }

  goToScreen(screenId, callback = null, skipLockScreenCheck = false, options = {}) {
    // Screen skip in/out transition, if currentTransitionString is listed in exceptions array
    const currentTransitionString = `${this.currentScreen}->${screenId}`;
    if (["1->2"].includes(currentTransitionString)) {
      options.skipOut = options.skipIn = true;
    }

    if (["1->2"].includes(currentTransitionString)) {
      this.replayVideo(".main-background");
    }

    const applyTransition = this.screenTransition.transition(this.currentScreen, screenId, callback,
      (combinedCallback) => {
        if (super.goToScreen(screenId, combinedCallback, skipLockScreenCheck, options)) {
          this.sendScreenBridgeMessage("gotoScreen " + screenId);
        }
      }
    );

    if (applyTransition !== false) this.sendScreenBridgeMessage("lockInteraction");
  }

  goToNextScreen(callback) {
    this.goToScreen(parseInt(this.currentScreen) + 1, callback);
  };

  goToPreviousScreen(callback) {
    const $screenIdDestination = parseInt(this.currentScreen) - 1;
    if ($screenIdDestination === 1) {
      this.reset(1);
    } else if ($screenIdDestination === 2) {
      this.cancelScenario();
    } else {
      this.goToScreen($screenIdDestination, callback);
    }
  };

  onScreenBridgeMessage(messageString) {
    super.onScreenBridgeMessage(messageString);
    if (messageString.startsWith("startApp")) {
      this.goToScreen(2);
    } else if (messageString.startsWith("startScenario")) {
      const selectedScenario = messageString.replace("startScenario ", "");
      this.loadScenario(selectedScenario)
    } else if (messageString.startsWith("cancelScenario")) {
      this.cancelScenario();
    }
  }

  findScenarioByMachineName(scenarios, machineName) {
    return scenarios.find((s) => s.machine_name === machineName) ?? null;
  }

  /**
   * Reset function, used to go back clean version of the game
   * @param screenId
   */
  reset(screenId) {

    // Reset redirect timeout
    if (this.redirectTimeout !== false) {
      clearTimeout(this.redirectTimeout);
      this.redirectTimeout = false;
    }

    if (this.startTimeout !== null) {
      clearTimeout(this.startTimeout)
      this.startTimeout = null;
    }

    // Tear down any active scenario and unload the iframe (e.g. screensaver kicked in mid-scenario)
    this.cleanUpScenario();
    this.selectedScenario = null;

    // Reset variable and timeline
    this.killTimeline(this.currentTimeline);
    this.blurryLettersAnim.reset();

    this.replayVideo("#screen-1 .screen-background");

    const resetCallback = () => {
      // Things that reset after goToScreen
      this.sendScreenBridgeMessage("/send idle");
      this.starting = false;

      $("#screen-3 .scenario.selected").removeClass("selected");
    }

    // Super
    return super.reset(screenId, resetCallback);
  }

}
